module.exports = __webpack_public_path__ + "img/Color S134.8947cf37.jpg";